// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/govcon/v1/govcon.proto (package mono.govcon.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AnalyzeContractRequest, AnalyzeContractResponse, AnalyzeModificationRequest, AnalyzeModificationResponse, AnalyzeModificationV2Request, AnalyzeModificationV2Response, ClassifyContractRequest, ClassifyContractResponse, ClassifyDocumentRequest, ClassifyDocumentResponse, ClassifyPackageRequest, ClassifyPackageResponse, ClassifyProposalRequest, ClassifyProposalResponse, ClassifySpreadsheetRequest, ClassifySpreadsheetResponse, CompareAmendmentsRequest, CompareAmendmentsResponse, DetectAmbiguitiesRequest, DetectAmbiguitiesResponse, ExpandSentencesRequest, ExpandSentencesResponse, ExtractAwardedContractRequest, ExtractAwardedContractResponse, ExtractAwardedContractV2Request, ExtractAwardedContractV2Response, ExtractBlocksRequest, ExtractBlocksResponse, ExtractBlocksUploadRequest, ExtractBlocksUploadResponse, ExtractCapabilitiesRequest, ExtractCapabilitiesResponse, ExtractCLINsRequest, ExtractCLINsResponse, ExtractDocumentTextRequest, ExtractDocumentTextResponse, ExtractGlossaryRequest, ExtractGlossaryResponse, ExtractLCATsRequest, ExtractLCATsResponse, ExtractOutlineRequest, ExtractOutlineResponse, ExtractPricingTemplateRequest, ExtractPricingTemplateResponse, ExtractProjectLCATsRequest, ExtractProjectLCATsResponse, ExtractRateObservationsRequest, ExtractRateObservationsResponse, GenerateComplianceMatrixRequest, GenerateComplianceMatrixResponse, GenerateMasterMatrixRequest, GenerateMasterMatrixResponse, GetBlockRequest, GetBlockResponse, GetPricingSheetPageRequest, GetPricingSheetPageResponse, InspectPricingSheetRequest, InspectPricingSheetResponse, MatchCapabilitiesRequest, MatchCapabilitiesResponse, MergeProjectArtifactRequest, MergeProjectArtifactResponse, ParseDocumentStructureRequest, ParseDocumentStructureResponse, PreviewRateSheetRequest, PreviewRateSheetResponse, ProcessDocumentRequest, ProcessDocumentResponse, ProcessPackageRequest, ProcessPackageResponse, ProcessQARequest, ProcessQAResponse, ReExtractPricingSheetRequest, ReExtractPricingSheetResponse, ShredDocumentsRequest, ShredDocumentsResponse } from "./govcon_pb";
import { MethodKind } from "@bufbuild/protobuf";
import { ExtractExecutionScopeArtifactRequest, ExtractExecutionScopeArtifactResponse } from "./execution_scope_pb";
/**
 * GovConService provides government contract document processing operations.
 *
 * @generated from service mono.govcon.v1.GovConService
 */ export const GovConService = {
    typeName: "mono.govcon.v1.GovConService",
    methods: {
        /**
     * ClassifyDocument classifies a single document by type.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ClassifyDocument
     */ classifyDocument: {
            name: "ClassifyDocument",
            I: ClassifyDocumentRequest,
            O: ClassifyDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * ClassifyPackage classifies documents within a ZIP or directory.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ClassifyPackage
     */ classifyPackage: {
            name: "ClassifyPackage",
            I: ClassifyPackageRequest,
            O: ClassifyPackageResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractBlocks extracts structured content blocks from a document path.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractBlocks
     */ extractBlocks: {
            name: "ExtractBlocks",
            I: ExtractBlocksRequest,
            O: ExtractBlocksResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractBlocksUpload extracts blocks from an uploaded file.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractBlocksUpload
     */ extractBlocksUpload: {
            name: "ExtractBlocksUpload",
            I: ExtractBlocksUploadRequest,
            O: ExtractBlocksUploadResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetBlock returns a specific block from a document along with a configurable
     * number of surrounding context blocks. Server-side shortcut around
     * ExtractBlocks for agent tools that only need one block at a time.
     *
     * @generated from rpc mono.govcon.v1.GovConService.GetBlock
     */ getBlock: {
            name: "GetBlock",
            I: GetBlockRequest,
            O: GetBlockResponse,
            kind: MethodKind.Unary
        },
        /**
     * ProcessDocument runs the full GovCon pipeline (classify + extract + excel).
     *
     * @generated from rpc mono.govcon.v1.GovConService.ProcessDocument
     */ processDocument: {
            name: "ProcessDocument",
            I: ProcessDocumentRequest,
            O: ProcessDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * ProcessPackage processes a ZIP or directory of documents.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ProcessPackage
     */ processPackage: {
            name: "ProcessPackage",
            I: ProcessPackageRequest,
            O: ProcessPackageResponse,
            kind: MethodKind.Unary
        },
        /**
     * ShredDocuments extracts requirements from document blocks.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ShredDocuments
     */ shredDocuments: {
            name: "ShredDocuments",
            I: ShredDocumentsRequest,
            O: ShredDocumentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GenerateComplianceMatrix generates a compliance matrix from shredded requirements.
     *
     * @generated from rpc mono.govcon.v1.GovConService.GenerateComplianceMatrix
     */ generateComplianceMatrix: {
            name: "GenerateComplianceMatrix",
            I: GenerateComplianceMatrixRequest,
            O: GenerateComplianceMatrixResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractCLINs extracts Contract Line Item Numbers from blocks or Excel.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractCLINs
     */ extractCLINs: {
            name: "ExtractCLINs",
            I: ExtractCLINsRequest,
            O: ExtractCLINsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractLCATs extracts labor categories from document blocks.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractLCATs
     */ extractLCATs: {
            name: "ExtractLCATs",
            I: ExtractLCATsRequest,
            O: ExtractLCATsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ClassifyProposal classifies a proposal document from storage (v2 classifier).
     *
     * @generated from rpc mono.govcon.v1.GovConService.ClassifyProposal
     */ classifyProposal: {
            name: "ClassifyProposal",
            I: ClassifyProposalRequest,
            O: ClassifyProposalResponse,
            kind: MethodKind.Unary
        },
        /**
     * ParseDocumentStructure parses HTML into structured blocks and builds a document outline.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ParseDocumentStructure
     */ parseDocumentStructure: {
            name: "ParseDocumentStructure",
            I: ParseDocumentStructureRequest,
            O: ParseDocumentStructureResponse,
            kind: MethodKind.Unary
        },
        /**
     * MergeProjectArtifact merges per-document artifacts into a single project-level file.
     *
     * @generated from rpc mono.govcon.v1.GovConService.MergeProjectArtifact
     */ mergeProjectArtifact: {
            name: "MergeProjectArtifact",
            I: MergeProjectArtifactRequest,
            O: MergeProjectArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * DetectAmbiguities scans requirements for ambiguous language patterns.
     *
     * @generated from rpc mono.govcon.v1.GovConService.DetectAmbiguities
     */ detectAmbiguities: {
            name: "DetectAmbiguities",
            I: DetectAmbiguitiesRequest,
            O: DetectAmbiguitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * CompareAmendments compares base and amendment requirements to detect changes.
     *
     * @generated from rpc mono.govcon.v1.GovConService.CompareAmendments
     */ compareAmendments: {
            name: "CompareAmendments",
            I: CompareAmendmentsRequest,
            O: CompareAmendmentsResponse,
            kind: MethodKind.Unary
        },
        /**
     * GenerateMasterMatrix builds a master requirement matrix across amendments.
     *
     * @generated from rpc mono.govcon.v1.GovConService.GenerateMasterMatrix
     */ generateMasterMatrix: {
            name: "GenerateMasterMatrix",
            I: GenerateMasterMatrixRequest,
            O: GenerateMasterMatrixResponse,
            kind: MethodKind.Unary
        },
        /**
     * ProcessQA parses Q&A Excel files, analyzes impact, and links to requirements.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ProcessQA
     */ processQA: {
            name: "ProcessQA",
            I: ProcessQARequest,
            O: ProcessQAResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExpandSentences splits multi-sentence blocks into individual sentence blocks.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExpandSentences
     */ expandSentences: {
            name: "ExpandSentences",
            I: ExpandSentencesRequest,
            O: ExpandSentencesResponse,
            kind: MethodKind.Unary
        },
        /**
     * ClassifySpreadsheet classifies XLSX/CSV files using custom parsing (no Marker/Datalab).
     *
     * @generated from rpc mono.govcon.v1.GovConService.ClassifySpreadsheet
     */ classifySpreadsheet: {
            name: "ClassifySpreadsheet",
            I: ClassifySpreadsheetRequest,
            O: ClassifySpreadsheetResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractProjectLCATs extracts labor categories across all project documents.
     * Uses merged CLINs + PWS/attachment document content for comprehensive bottom-up extraction.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractProjectLCATs
     */ extractProjectLCATs: {
            name: "ExtractProjectLCATs",
            I: ExtractProjectLCATsRequest,
            O: ExtractProjectLCATsResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractPricingTemplate extracts V2 composable pricing templates from xlsx files.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractPricingTemplate
     */ extractPricingTemplate: {
            name: "ExtractPricingTemplate",
            I: ExtractPricingTemplateRequest,
            O: ExtractPricingTemplateResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractRateObservations reads a published rate sheet and files each rate in
     * the rate book, through pangaea. A rate whose labor category is not yet
     * registered becomes a labor-category CANDIDATE rather than an observation:
     * delivery.rate_observations requires an lcat_entry_id and inventing one would
     * attach real money to a category no human approved.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractRateObservations
     */ extractRateObservations: {
            name: "ExtractRateObservations",
            I: ExtractRateObservationsRequest,
            O: ExtractRateObservationsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Read what a pricing sheet says about itself, WITHOUT staging anything. The
     * upload flow calls this first so it can show a person what was found and ask
     * whether it is right, instead of asking them to type it in.
     *
     * @generated from rpc mono.govcon.v1.GovConService.InspectPricingSheet
     */ inspectPricingSheet: {
            name: "InspectPricingSheet",
            I: InspectPricingSheetRequest,
            O: InspectPricingSheetResponse,
            kind: MethodKind.Unary
        },
        /**
     * Read a pricing sheet's RATES without staging anything: the same parser and
     * registry match ExtractRateObservations runs, with every write recorded
     * instead of made. Chat uses it to show a published sheet as rows before
     * anyone decides to stage it.
     *
     * @generated from rpc mono.govcon.v1.GovConService.PreviewRateSheet
     */ previewRateSheet: {
            name: "PreviewRateSheet",
            I: PreviewRateSheetRequest,
            O: PreviewRateSheetResponse,
            kind: MethodKind.Unary
        },
        /**
     * Read a sheet AGAIN from the artifact it was originally uploaded as, without
     * asking anyone to find the file. The parser changes daily while this track is
     * being built, and re-uploading by hand to see the effect is the slowest part
     * of the loop.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ReExtractPricingSheet
     */ reExtractPricingSheet: {
            name: "ReExtractPricingSheet",
            I: ReExtractPricingSheetRequest,
            O: ReExtractPricingSheetResponse,
            kind: MethodKind.Unary
        },
        /**
     * Render one page of an uploaded pricing sheet, with the boxes of the blocks
     * the parser read on it. This is what lets a reviewer SEE the claim: a staged
     * rate names a block, and a block id is a string until it is a rectangle on
     * the page it came from.
     *
     * @generated from rpc mono.govcon.v1.GovConService.GetPricingSheetPage
     */ getPricingSheetPage: {
            name: "GetPricingSheetPage",
            I: GetPricingSheetPageRequest,
            O: GetPricingSheetPageResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractAwardedContract pulls structured data out of a fully-executed
     * award-package PDF. Phase 0b consumer: zou's awardcompare engine
     * (services/zou/pkg/awardcompare/) diffs the result against the frozen
     * BidBaseline + ReadinessPackages to surface DiscrepancyDraft rows.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractAwardedContract
     */ extractAwardedContract: {
            name: "ExtractAwardedContract",
            I: ExtractAwardedContractRequest,
            O: ExtractAwardedContractResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractAwardedContractV2 (Phase 4c-3) — field-level extraction where every
     * value carries source metadata (page/section/bbox). Additive: V1 above is
     * untouched. The returned source_references[] are PROPOSED — the orchestrator
     * persists them via pangaea BulkInsertSourceReferences for review.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractAwardedContractV2
     */ extractAwardedContractV2: {
            name: "ExtractAwardedContractV2",
            I: ExtractAwardedContractV2Request,
            O: ExtractAwardedContractV2Response,
            kind: MethodKind.Unary
        },
        /**
     * AnalyzeContract extracts contract-specific metadata: header, parties, PoP, places of performance.
     * Used by the contract_processing pipeline (Phase 6). Does NOT extract CLINs (use ExtractCLINs for that).
     *
     * @generated from rpc mono.govcon.v1.GovConService.AnalyzeContract
     */ analyzeContract: {
            name: "AnalyzeContract",
            I: AnalyzeContractRequest,
            O: AnalyzeContractResponse,
            kind: MethodKind.Unary
        },
        /**
     * ClassifyContract classifies a document uploaded to a contract project.
     * Uses contract-specific taxonomy (~25 types) grouped into primary categories
     * (BASE, MODIFICATION, DELIVERABLE, FINANCIAL, PERSONNEL, ADMIN, ATTACHMENT).
     *
     * @generated from rpc mono.govcon.v1.GovConService.ClassifyContract
     */ classifyContract: {
            name: "ClassifyContract",
            I: ClassifyContractRequest,
            O: ClassifyContractResponse,
            kind: MethodKind.Unary
        },
        /**
     * AnalyzeModification extracts structured changes from a contract modification (SF-30).
     * Reads the narrative section (not replacement schedules) to extract FROM/TO changes
     * for PoP, funding, scope, and parties. Used during per-doc contract_processing for
     * MODIFICATION documents. Results feed into contract_analysis cross-doc merge.
     *
     * @generated from rpc mono.govcon.v1.GovConService.AnalyzeModification
     */ analyzeModification: {
            name: "AnalyzeModification",
            I: AnalyzeModificationRequest,
            O: AnalyzeModificationResponse,
            kind: MethodKind.Unary
        },
        /**
     * AnalyzeModificationV2 (Phase 4d) — deterministic field-level modification
     * extraction. Emits ModifiedFieldV2 deltas (old -> new) addressed to
     * (target_object_type, target_object_id, target_field_path) plus a parallel
     * source_references[], so the orchestrator can map a modification onto a
     * canonical ContractChangeSet mechanically. Additive: V1 above is untouched.
     *
     * @generated from rpc mono.govcon.v1.GovConService.AnalyzeModificationV2
     */ analyzeModificationV2: {
            name: "AnalyzeModificationV2",
            I: AnalyzeModificationV2Request,
            O: AnalyzeModificationV2Response,
            kind: MethodKind.Unary
        },
        /**
     * ExtractCapabilities extracts structured capabilities from vendor documents
     * (past performance reports, PWS deliverables, case studies, resumes).
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractCapabilities
     */ extractCapabilities: {
            name: "ExtractCapabilities",
            I: ExtractCapabilitiesRequest,
            O: ExtractCapabilitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * MatchCapabilities scores candidate capabilities against a requirement.
     *
     * @generated from rpc mono.govcon.v1.GovConService.MatchCapabilities
     */ matchCapabilities: {
            name: "MatchCapabilities",
            I: MatchCapabilitiesRequest,
            O: MatchCapabilitiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractOutline is a fast-path RPC that reads OOXML directly (no Marker,
     * no LLM) and returns the document's heading structure (DOCX), sheet names
     * (XLSX), or slide titles (PPTX). Sub-second execution. Used by zou to
     * sync OutlineSection rows on every OnlyOffice save.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractOutline
     */ extractOutline: {
            name: "ExtractOutline",
            I: ExtractOutlineRequest,
            O: ExtractOutlineResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractDocumentText is a fast-path RPC that reads OOXML directly and
     * returns the full text content. Sub-second execution. Used by shanks
     * to read volume document content before writing.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractDocumentText
     */ extractDocumentText: {
            name: "ExtractDocumentText",
            I: ExtractDocumentTextRequest,
            O: ExtractDocumentTextResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractExecutionScopeArtifact emits source-backed execution-scope claims
     * plus an exhaustive source-unit coverage ledger. Pure with respect to
     * delivery truth: no authoritative database mutation. Messages live in
     * execution_scope.proto. Wave 0 returns Unimplemented until Lane D.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractExecutionScopeArtifact
     */ extractExecutionScopeArtifact: {
            name: "ExtractExecutionScopeArtifact",
            I: ExtractExecutionScopeArtifactRequest,
            O: ExtractExecutionScopeArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExtractGlossary (SAD-857) reads the terms one program document defines
     * for the program glossary. Code reads every printed definition ("System
     * Security Plan (SSP)", "SSP (System Security Plan)", an acronym table);
     * with ask_model, a reader proposes what each acronym the document uses but
     * never defines stands for and Jev keeps only what it confirms at 0.9. It
     * writes nothing: reverie stores each section through pangaea.
     *
     * @generated from rpc mono.govcon.v1.GovConService.ExtractGlossary
     */ extractGlossary: {
            name: "ExtractGlossary",
            I: ExtractGlossaryRequest,
            O: ExtractGlossaryResponse,
            kind: MethodKind.Unary
        }
    }
};
